





















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  name: 'BasePasswordValidator',
  components: {
    Icon,
  },
})
export default class BasePasswordValidator extends Vue {
  @Prop() input: string;
  @Prop() showErrors: boolean;

  @Watch('input')
  newInput() {
    this.$emit('isValidPassword', this.isValidPassword);
  }

  get hasMinCharacters(): boolean {
    const minLengthRegex = /.{8,}/;
    return this.validateInput(this.input, minLengthRegex);
  }

  get hasUpperCase(): boolean {
    const uppercaseRegex = /[A-Z]/;
    return this.validateInput(this.input, uppercaseRegex);
  }

  get hasLowerCase(): boolean {
    const lowercaseRegex = /[a-z]/;
    return this.validateInput(this.input, lowercaseRegex);
  }

  get hasNumber(): boolean {
    const numberRegex = /\d/;
    return this.validateInput(this.input, numberRegex);
  }

  get isValidPassword(): boolean {
    return this.hasMinCharacters && this.hasUpperCase && this.hasLowerCase && this.hasNumber;
  }

  validClass(isValid: boolean): string {
    if (isValid) {
      return 'valid';
    }
    if (!this.showErrors) {
      return '';
    }

    return 'invalid';
  }

  icon(isValid: boolean): string {
    if (!this.showErrors) {
      return 'check-icon';
    }
    return isValid ? 'check-icon' : 'check-icon-invalid';
  }

  validateInput(input: string, regex: RegExp) {
    return regex.test(input);
  }
}
